/* ============================================================
   luxe-bundles-v2.js  (site-redesign-2026, Phase 3c)
   Frozen reference: design/bundles-sample-v4.html.
   Two jobs, vanilla + deferred, no dependencies:

     1. CHIP FILTER — filters bundle cards in place by data-category,
        aria-pressed, updates the polite "Showing N bundles" line, and
        HIDES a chapter's whole wrapper (head + curves + stone band) when
        the active chip empties it.

     2. MULTI-ITEM ATC — POST /cart/add.js with an items[] array, then
        re-render the mini-cart via the theme's Section Rendering API and
        open the drawer exactly the way a native PDP add does
        (mini-cart.renderContents opens it). Same proven path as the
        legacy luxe-bundles.js.
   ============================================================ */
(function () {
  'use strict';

  function slice(nodelist) { return Array.prototype.slice.call(nodelist); }

  /* ---------------------------------------------------------------------
     1. CHIP FILTER
     --------------------------------------------------------------------- */
  function initFilter(root) {
    if (root.dataset.luxeFilterInit === 'true') return;
    root.dataset.luxeFilterInit = 'true';

    var chips = slice(root.querySelectorAll('[data-luxe-chip]'));
    if (!chips.length) return;

    var countEl = root.querySelector('[data-luxe-bnd-count]');
    var prefix = countEl ? (countEl.getAttribute('data-prefix') || '') : '';
    var suffix = countEl ? (countEl.getAttribute('data-suffix') || '') : '';
    var cards = slice(root.querySelectorAll('[data-luxe-bundle-card]'));
    var chapters = slice(root.querySelectorAll('[data-luxe-chapter]'));

    function setCount(n) {
      if (countEl) countEl.textContent = (prefix + ' ' + n + ' ' + suffix).trim();
    }

    function apply(cat) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = cat === 'all' || (card.getAttribute('data-category') || '') === cat;
        card.hidden = !match;
        if (match) shown++;
      });
      /* Hide a chapter wrapper (head + seams + stone) once it has no visible cards. */
      chapters.forEach(function (ch) {
        var visible = ch.querySelectorAll('[data-luxe-bundle-card]:not([hidden])').length;
        ch.hidden = visible === 0;
      });
      setCount(shown);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('luxe-bnd__chip--on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(chip.getAttribute('data-luxe-chip'));
      });
    });

    /* Initial count from the DOM (source of truth once rendered). */
    setCount(cards.length);
  }

  /* ---------------------------------------------------------------------
     2. MULTI-ITEM ATC  (cart-mode routine cards)
     --------------------------------------------------------------------- */
  function initATC(root) {
    if (root.dataset.luxeAtcInit === 'true') return;
    root.dataset.luxeAtcInit = 'true';

    var buttons = slice(root.querySelectorAll('button[data-luxe-atc-items]'));
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items;
        try {
          items = JSON.parse(btn.getAttribute('data-luxe-atc-items'));
        } catch (e) {
          console.error('[luxe-bundles-v2] bad data-luxe-atc-items JSON', e);
          return;
        }
        if (!items || !items.length) return;

        var label = btn.querySelector('span');
        var original = label ? label.textContent : '';
        btn.setAttribute('disabled', 'disabled');
        if (label) label.textContent = btn.getAttribute('data-label-adding') || 'Adding…';

        var miniCart = document.querySelector('mini-cart');

        /* FormData carries items[] + the sections list the theme needs to
           re-render the drawer, mirroring the native product-form submit. */
        var formData = new FormData();
        items.forEach(function (item, i) {
          formData.append('items[' + i + '][id]', item.id);
          formData.append('items[' + i + '][quantity]', item.quantity || 1);
        });
        if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
          var ids = miniCart.getSectionsToRender().map(function (sec) { return sec.section; });
          formData.append('sections', ids.join(','));
          formData.append('sections_url', window.location.pathname);
          if (typeof miniCart.setActiveElement === 'function') miniCart.setActiveElement(btn);
        }

        var url = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';

        fetch(url, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (res) {
            return res.json().then(function (parsed) {
              if (!res.ok || parsed.status) {
                throw new Error(parsed.description || parsed.message || ('HTTP ' + res.status));
              }
              return parsed;
            });
          })
          .then(function (response) {
            if (label) label.textContent = btn.getAttribute('data-label-added') || 'Added ✓';

            /* Let the theme's other listeners (badges, analytics) update. */
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'luxe-bundles-v2',
                  productVariantId: items[0].id,
                  cartData: response
                });
              } catch (_) { /* swallow */ }
            }

            /* renderContents re-renders AND opens the drawer (native path). */
            if (miniCart && typeof miniCart.renderContents === 'function') {
              miniCart.renderContents(response);
              if (miniCart.classList && miniCart.classList.contains('is-empty')) {
                miniCart.classList.remove('is-empty');
              }
            } else {
              window.location = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
              return;
            }

            setTimeout(function () {
              if (label) label.textContent = original;
              btn.removeAttribute('disabled');
            }, 1800);
          })
          .catch(function (err) {
            console.error('[luxe-bundles-v2] ATC error', err);
            if (label) label.textContent = btn.getAttribute('data-label-error') || 'Try again';
            setTimeout(function () {
              if (label) label.textContent = original;
              btn.removeAttribute('disabled');
            }, 1500);
          });
      });
    });
  }

  function initRoot(root) {
    initFilter(root);
    initATC(root);
  }

  function boot() {
    slice(document.querySelectorAll('[data-luxe-bundles]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init when the section reloads. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-luxe-bundles]') : null;
    if (root) initRoot(root);
  });
})();
